import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/nav.css";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import NotFound from "./components/NotFound";
import Properties from "./pages/Properties";
import Property from "./pages/Property";
import Faq from "./pages/Faq";
import StoreContext from "./context/store";

function ScrollRevealController() {
  const location = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    if (typeof window.IntersectionObserver !== "function") {
      document.querySelectorAll(".wow").forEach((element) => {
        element.classList.add("is-visible");
      });
      return undefined;
    }

    const observedElements = new WeakSet();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.getAttribute("data-wow-delay");
            if (delay) {
              entry.target.style.animationDelay = delay;
            }
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -40px 0px",
      }
    );

    const observeElement = (element) => {
      if (!element || observedElements.has(element)) {
        return;
      }

      element.classList.remove("is-visible");
      observer.observe(element);
      observedElements.add(element);
    };

    const collectAndObserve = (rootNode) => {
      if (!(rootNode instanceof Element)) {
        return;
      }

      if (rootNode.classList.contains("wow")) {
        observeElement(rootNode);
      }

      rootNode.querySelectorAll(".wow").forEach((element) => {
        observeElement(element);
      });
    };

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          collectAndObserve(node);
        });
      });
    });

    const run = window.requestAnimationFrame(() => {
      collectAndObserve(document.body);
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });

    return () => {
      window.cancelAnimationFrame(run);
      mutationObserver.disconnect();
      observer.disconnect();
    };
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <StoreContext>
      <Router>
        <ScrollRevealController />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property/:id" element={<Property />} />
          <Route path="/frequently-asked-questions" element={<Faq />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/404" element={<NotFound />} />
        </Routes>
      </Router>
    </StoreContext>
  );
}

export default App;
